export default __webpack_public_path__ + "static/media/white-rook.74e6d1a3.png";